import { useEffect, useMemo, useState } from "react";

import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress
} from "@mui/material";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import TableConfigForm from "./TableConfigForm";
import { MAIN_URL } from "../../../Configurations/Urls";
import axios from "axios";

export default function MultiTableConfig() {
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const tables = useMemo(() => [

    {
      id: "clients",
      tablename: "Clients",
      tableheading: "clients-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/clients?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Clients_grid_${org?.organization_id}`,
    },

    {
      id: "client-contacts",
      tablename: "Client Contacts",
      tableheading: "client-contacts-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/client-contacts?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Client-Contacts_grid_${org?.organization_id}`,
    },

    {
      id: "project-types",
      tablename: "Project Types",
      tableheading: "project-types-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-types?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Types_grid_${org?.organization_id}`,
    },
    {
      id: "project-categories",
      tablename: "Project Categories",
      tableheading: "project-categories-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-categories?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Categories_grid_${org?.organization_id}`,
    },
    {
      id: "project-sub-categories",
      tablename: "Project Sub Categories",
      tableheading: "project-sub-categories-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-sub-categories?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Sub Categories_grid_${org?.organization_id}`,
    },
    {
      id: "project-templates",
      tablename: "Project Templates",
      tableheading: "project-templates-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-templates?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Templates_grid_${org?.organization_id}`,
    },
    {
      id: "project-template-milestone",
      tablename: "Project Templates Milestone",
      tableheading: "project-template-milestone-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-template-milestone?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Templates Milestone_grid_${org?.organization_id}`,
    },
    {
      id: "project-template-tasks",
      tablename: "Project Templates Tasks",
      tableheading: "project-template-tasks-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-template-tasks?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project Templates Tasks_grid_${org?.organization_id}`,
    },
    {
      id: "projects",
      tablename: "Projects",
      tableheading: "projects-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/projects?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Projects_grid_${org?.organization_id}`,
    },
    {
      id: "projects_dashboard",
      tablename: "Projects (Dashboard)",
      tableheading: "projects-dashbaord-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/projects?organization_id=${org?.organization_id}&per_page=all&mode=2`,
      datagridKeyProp: `Projects_grid_dashboard_${org?.organization_id}`,
    },
    {
      id: "project-teams",
      tablename: "Project Teams",
      tableheading: "projects-teams-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-teams?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_teams_grid_${org?.organization_id}`,
    },
    {
      id: "project-team-members",
      tablename: "Project Team Members",
      tableheading: "projects-team-members-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-team-members?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_team_members_grid_${org?.organization_id}`,
    },
    {
      id: "project-milestone",
      tablename: "Project MileStone",
      tableheading: "projects-milestone-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-milestone?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_milestone_grid_${org?.organization_id}`,
    },
    {
      id: "project-tasks",
      tablename: "Project Tasks",
      tableheading: "project-tasks-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-tasks?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_tasks_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-recurrence",
      tablename: "Project Task Recurrence",
      tableheading: "project-task-recurrence-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-recurrence?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_recurrence_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-schedule",
      tablename: "Project Task Schedule",
      tableheading: "project-task-schedule-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-schedule?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_schedule_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-template",
      tablename: "Project Task Template",
      tableheading: "project-task-template-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-template?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_template_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-category",
      tablename: "Project Task Category",
      tableheading: "project-task-category-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-category?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_category_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-sub-category",
      tablename: "Project Task Sub Category",
      tableheading: "project-task-sub-category-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-sub-category?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_sub_category_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-type",
      tablename: "Project Task Type",
      tableheading: "project-task-type-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-type?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_type_grid_${org?.organization_id}`,
    },
    {
      id: "project-task-schedule-timelog",
      tablename: "Project Task Schedule Timelog",
      tableheading: "project-task-schedule-timelog-list",
      apiFieldsConfig: `${MAIN_URL}/api/project-management/project-task-schedule-timelog?organization_id=${org?.organization_id}&per_page=all&mode=1`,
      datagridKeyProp: `Project_task_schedule_timelog_grid_${org?.organization_id}`,
    },

    // Organization setup
    {
      id: "organization-entities",
      tablename: "Organization Entities",
      tableheading: "organization-entities-list",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/entity?mode=2`,
      datagridKeyProp: `organization_entities_grid_${org?.organization_id}`,
    },
    {
      id: "locations",
      tablename: "Locations",
      tableheading: "locations",
      apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/location?mode=1`,
      datagridKeyProp: `Locations_grid_${org?.organization_id}`,
    },

   
    {
      id: "departments",
      tablename: "Departments",
      tableheading: "Departments",
      apiFieldsConfig:`${MAIN_URL}/api/organizations/${org?.organization_id}/department?mode=1`,
      datagridKeyProp: `departments_grid_${org?.organization_id}`,
    },
    {
      id: "designation",
      tablename: "Designation",
      tableheading: "Designation",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/designation?mode=1`,
      datagridKeyProp: `Designations_grid_${org?.organization_id}`,
    },

    {
      id: "work_shifts",
      tablename: "Work Shifts",
      tableheading: "work_shifts",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/workshift?mode=1`,
      datagridKeyProp: `organization_work_shifts_grid_${org?.organization_id}`,
    },
    // User management
    {
      id: "users",
      tablename: "Users",
      tableheading: "users",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/user?mode=1`,
      datagridKeyProp: `Users_grid_${org?.organization_id}`,
    },
    {
      id: "user_role",
      tablename: "User Roles",
      tableheading: "user_role",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/userrole?mode=1`,
      datagridKeyProp: `User Roles_grid_${org?.organization_id}`,
    },


    // Employee management
    {
      id: "employees",
      tablename: "Employees",
      tableheading: "employee-list",
      apiFieldsConfig:    `${MAIN_URL}/api/organizations/${org?.organization_id}/employee?mode=2`,
      datagridKeyProp: `Employees_grid_${org?.organization_id}`,
    },

    {
      id: "employee_exit",
      tablename: "Employee Exits",
      tableheading: "employee_exit",
      apiFieldsConfig: `${MAIN_URL}/api/organizations/${org?.organization_id}/employee-exit?mode=1`,
      datagridKeyProp: `employee_exits_grid_${org?.organization_id}`,
    },
  ], [org?.organization_id]);





  const [activeTableId, setActiveTableId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autoColumns, setAutoColumns] = useState([]);

  // Set initial active table
  useEffect(() => {
    if (tables?.length > 0 && !activeTableId) {
      setActiveTableId(tables[0].id);
    }
  }, [tables, activeTableId]);

  // Get current active table object
  const activeTable = useMemo(() => {
    return tables.find(t => t.id === activeTableId);
  }, [tables, activeTableId]);

  

  useEffect(() => {
    if (!activeTable?.apiFieldsConfig) return;

    setLoading(true);
    setData([]);

    const token = localStorage.getItem("token");

    axios
      .get(activeTable.apiFieldsConfig, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const result = response.data;
        // Handle different possible structures
        const dataArray = result.data.data || result.data || result.rows || result || [];

        console.log("dataArray is : " , dataArray);
        
        setData(Array.isArray(dataArray) ? dataArray : []);
      })
      .catch((error) => {
        console.error("Axios error:", error);
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activeTable]);


  // Handle dropdown change
  const handleTableChange = (event) => {
    setActiveTableId(event.target.value);
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
        <InputLabel id="table-datagrid-label">Select DataGrid</InputLabel>
        <Select
          labelId="table-datagrid-label"
          id="table-datagrid"
          value={activeTableId}
          label="Select DataGrid"
          onChange={handleTableChange}
        >
          {tables.map((table) => (
            <MenuItem key={table.id} value={table.id}>
              {table.tablename}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading {activeTable?.tablename}...</Typography>
        </Box>
      )}

      {!loading && activeTable && (
        <TableConfigForm
          tablename={activeTable.tablename}
          tableheading={activeTable.tableheading}
          apiFieldsConfig={activeTable.apiFieldsConfig}
          datagridKeyProp={activeTable.datagridKeyProp}
          data={data}
          autoColumns={autoColumns}
        />
      )}
    </Box>
  );
}

